import { render, staticRenderFns } from "./glutes_buttock.vue?vue&type=template&id=57b38901"
import script from "./glutes_buttock.vue?vue&type=script&lang=js"
export * from "./glutes_buttock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports